/**
 * Check if colour theme is dark
 * @param {string} colourScheme - Colour string name
 * @returns {boolean}
 */
const isDarkColour = (colourScheme) =>
  colourScheme === 'darkGreen' || colourScheme === 'dark';

export default isDarkColour;
